import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Skeleton } from '@sorare/core/src/atoms/loader/Skeleton';

import { CompetitionDetailsGameplayBudgetRequirements_NBALeaderboardRequirements } from './__generated__/index.graphql';

type Props = {
  requirements?: CompetitionDetailsGameplayBudgetRequirements_NBALeaderboardRequirements | null;
};

export const BudgetRequirements = ({ requirements }: Props) => {
  const { allowMVP = true, tenGameAverageTotalLimit: budget } =
    requirements || {};
  return (
    <Skeleton loading={!requirements}>
      <FormattedMessage
        id="CompetitionDetails.BudgetRequirements"
        defaultMessage="{allowMVP,select, true {MVP + {budget} PTS} other {{budget} PTS}}"
        values={{ allowMVP, budget }}
      />
    </Skeleton>
  );
};

BudgetRequirements.fragments = {
  NBALeaderboardRequirements: gql`
    fragment CompetitionDetailsGameplayBudgetRequirements_NBALeaderboardRequirements on NBALeaderboardRequirements {
      tenGameAverageTotalLimit
      allowMVP
    }
  ` as TypedDocumentNode<CompetitionDetailsGameplayBudgetRequirements_NBALeaderboardRequirements>,
};
